export default {
    UNSUBMITTED: "UNSUBMITTED",
    SUBMITTED: "SUBMITTED",
    ERROR: "ERROR",
    SUCCESS: "SUCCESS",
    LOADING: "LOADING",
    INVALID: "INVALID",
    INVALID_NAME: "INVALID_NAME",
    INVALID_PHONE: "INVALID_PHONE",
    INVALID_EMAIL: "INVALID_EMAIL",
    INVALID_COURSE: "INVALID_COURSE",
    INVALID_MESSAGE: "INVALID_MESSAGE",
}

export const CONTACT_FORM_URL = `https://docs.google.com/forms/d/e/1FAIpQLSfjyw3xrCHkAhnYPf0MZiD92L19PG0imHY_RZBWyWL1xwa3Kg/formResponse`;

export const FORM_MESSAGE = {
    SUCCESS: "Form submitted successfully",
    ERROR: "Form submission failed",
    INVALID: "Please fill all the fields correctly",
}